// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_StatusesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /subaccounts/anticipations/statuses
 *
 * dados is the static anticipation status map from
 * Payment_anticipations_model::getAllStatusInfo() (const STATUS_INFO). The map
 * is a FIXED, closed set of exactly seven status codes — PENDING, SCHEDULED,
 * CREDITED, DEBITED, DENIED, CANCELLED, OVERDUE — each compiled into the
 * constant verbatim (no dynamic keys). Every value shares the
 * SubaccountsAnticipations_StatusesRow shape (`{name, description, severity,
 * is_final}`).
 *
 * Because the key set is closed and known at compile time, dados is modeled as
 * an object with one typed Row property per status code (default getDados()
 * reflects the public typed properties into the assoc array keyed by property
 * name). This yields a precise per-status runtime schema instead of an opaque
 * `Record<string, Row>` whose dynamic-key shape the runtime validator cannot
 * express.
 *
 * @see anticipations.php::statuses()
 */
import type { SubaccountsAnticipations_StatusesRow } from './SubaccountsAnticipations_StatusesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_StatusesResponseDados {
PENDING: SubaccountsAnticipations_StatusesRow
SCHEDULED: SubaccountsAnticipations_StatusesRow
CREDITED: SubaccountsAnticipations_StatusesRow
DEBITED: SubaccountsAnticipations_StatusesRow
DENIED: SubaccountsAnticipations_StatusesRow
CANCELLED: SubaccountsAnticipations_StatusesRow
OVERDUE: SubaccountsAnticipations_StatusesRow
}

export type SubaccountsAnticipations_StatusesResponse = ApiResponse<SubaccountsAnticipations_StatusesResponseDados>;

registerResponseContract('SubaccountsAnticipations_StatusesResponse', {
  PENDING: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  SCHEDULED: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  CREDITED: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  DEBITED: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  DENIED: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  CANCELLED: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
  OVERDUE: {
    type: 'object',
    required: true,
    fields: {
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: true },
      severity:    { type: 'string',  required: true },
      is_final:    { type: 'boolean', required: true },
    },
  },
})
